import React from 'react';
import { Icon } from './Icon';

const UnitsIcon = ({ size }: Props) => {
  const color = '#FF772C';
  const backgroundColor = '#FFD9C4';
  return (
    <div className={`avatar flex-shrink-0 ${size ? 'avatar-' + size : ''}`}>
      <span className="avatar-initial rounded" style={{ backgroundColor: backgroundColor, color: color }}>
        <i className={`ti ti-square-dot ti-${size ||'md'}`}></i>
      </span>
    </div>
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { UnitsIcon };